export default "__VITE_ASSET__BIMVyRvo__"